"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

class SubscriptionTier {
  static thaw(subscriptionTierObj) {
    if (subscriptionTierObj == null) return null;
    const subscriptionTier = new SubscriptionTier();
    if (subscriptionTierObj.id != null) subscriptionTier.setId(subscriptionTierObj.id);
    if (subscriptionTierObj.name != null) subscriptionTier.setName(subscriptionTierObj.name);
    if (subscriptionTierObj.stripePriceId != null) subscriptionTier.setStripePriceId(subscriptionTierObj.stripePriceId);
    if (subscriptionTierObj.maxNumEvaluations != null) subscriptionTier.setMaxNumEvaluations(subscriptionTierObj.maxNumEvaluations);
    if (subscriptionTierObj.description != null) subscriptionTier.setDescription(subscriptionTierObj.description);
    if (subscriptionTierObj.segmentId != null) subscriptionTier.setSegmentId(subscriptionTierObj.segmentId);
    if (subscriptionTierObj.monthlyCost != null) subscriptionTier.setMonthlyCost(subscriptionTierObj.monthlyCost);
    if (subscriptionTierObj.additionalEvaluationCost != null) subscriptionTier.setAdditionalEvaluationCost(subscriptionTierObj.additionalEvaluationCost);
    return subscriptionTier;
  }

  static thawList(subscriptionTierObjList) {
    if (subscriptionTierObjList == null) return [];
    var subscriptionTiers = [];

    for (var i = 0; i < subscriptionTierObjList.length; i++) {
      subscriptionTiers.push(SubscriptionTier.thaw(subscriptionTierObjList[i]));
    }

    return subscriptionTiers;
  }

  static freeze(subscriptionTier) {
    if (subscriptionTier == null) return null;
    var subscriptionTierObj = {};
    if (subscriptionTier.getId() != null) subscriptionTierObj.id = subscriptionTier.getId();
    if (subscriptionTier.getName() != null) subscriptionTierObj.name = subscriptionTier.getName();
    if (subscriptionTier.getStripePriceId() != null) subscriptionTierObj.stripePriceId = subscriptionTier.getStripePriceId();
    if (subscriptionTier.getMaxNumEvaluations() != null) subscriptionTierObj.maxNumEvaluations = subscriptionTier.getMaxNumEvaluations();
    if (subscriptionTier.getDescription() != null) subscriptionTierObj.description = subscriptionTier.getDescription();
    if (subscriptionTier.getSegmentId() != null) subscriptionTierObj.segmentId = subscriptionTier.getSegmentId();
    if (subscriptionTier.getMonthlyCost() != null) subscriptionTierObj.monthlyCost = subscriptionTier.getMonthlyCost();
    if (subscriptionTier.getAdditionalEvaluationCost() != null) subscriptionTierObj.additionalEvaluationCost = subscriptionTier.getAdditionalEvaluationCost();
    return subscriptionTierObj;
  }

  static freezeList(subscriptionTiers) {
    if (subscriptionTiers == null) return [];
    var subscriptionTierObjList = [];

    for (var i = 0; i < subscriptionTiers.length; i++) {
      subscriptionTierObjList.push(SubscriptionTier.freeze(subscriptionTiers[i]));
    }

    return subscriptionTierObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setStripePriceId(null);
    this.setMaxNumEvaluations(null);
    this.setDescription(null);
    this.setSegmentId(null);
    this.setMonthlyCost(null);
    this.setAdditionalEvaluationCost(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setStripePriceId(stripePriceId) {
    this.stripePriceId = stripePriceId;
  }

  setMaxNumEvaluations(maxNumEvaluations) {
    this.maxNumEvaluations = maxNumEvaluations;
  }

  setDescription(description) {
    this.description = description;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setMonthlyCost(monthlyCost) {
    this.monthlyCost = monthlyCost;
  }

  setAdditionalEvaluationCost(additionalEvaluationCost) {
    this.additionalEvaluationCost = additionalEvaluationCost;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getStripePriceId() {
    return this.stripePriceId;
  }

  getMaxNumEvaluations() {
    return this.maxNumEvaluations;
  }

  getDescription() {
    return this.description;
  }

  getSegmentId() {
    return this.segmentId;
  }

  getMonthlyCost() {
    return this.monthlyCost;
  }

  getAdditionalEvaluationCost() {
    return this.additionalEvaluationCost;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = SubscriptionTier;